// zh.js
export default {
    lang:'语言',
    menu:{
        supportApp: '支持应用',
        supportBank: '支持银行',
        openProcess: '开通流程',
        successCase: '成功案例',
        partners: '合作伙伴',
        contactUs: '联系我们'
    },
    tabs:{
        safe: '安全',
        safeContent: '数据全程加密',
        flexible: '灵活部署',
        flexibleContent: '云部署及本地部署灵活可选',
    },
    stayTuned: '敬请期待',
    supportAppPlatform:{
        title: '支持应用平台',
        nsPlatform: '银企直连解决方案',
        nscontent: '客户财务专用电脑上安装的客户端，定期轮巡中间件服务，获取业务系统的付款等指令，通过预置密码解密并执行相应的银行操作，达到业务和银行直连效果。 该方案无安全隐患，指令在传输过程中全程加密，客户端安装在内网电脑，无外网暴露风险。指令执行结果定时反馈业务系统，全程记录在案，有据可查。',
        nsCorrespondingBank: '对应银行',
        otherPlatform: '其他应用'
    },
    openProcess:{
        stepOne:{
            title: '银行',
            contentOne: '企业向银行申请开通',
            contentTwo: '银企直连许可'
        },
        stepTwo:{
            title: '银企直连平台',
            contentOne: '注册平台用户',
            contentTwo: '开通权限许可'
        },
        stepThree:{
            title: 'ERP应用端',
            contentOne: '安装设置',
            contentTwo: '实施调试'
        },
        stepFour:{
            title: '开通',
            contentOne: '功能测试',
            contentTwo: '正式开通'
        } 
    },
    successCase:{
        yingtongTechnology: '鹰瞳科技',
        contentOne: '1. 账务信息银企同步。实时反映账户资金变化情况，便于企业财务监控和决策；实现资金流与业务流匹配。',
        contentTwo: '2. 资金集中管理。建立资金池，实现资金上下游调拨、归集，提高资金利用效率。为企业财务决策提供实时、准确、全面的账务信息支持',
        contentThree: '3. 省时增效。所有指令一次录入，减少财务人员手动操作环节和核算工作量，有效减少差错率。',
        contentFour: '4. 安全放心。除采用与网上银行相同的安全机制外，还在转账交易中增加了“签名时间”字段、在所有交易中增加了“包序列ID”字段，从而可有效地防止黑客攻击、指令重复提交。'
    },
    contactUs:{
        content:'售前团队为您提供售前咨询、产品及解决方案推荐、配置推荐等服务，助您开启互联，信息畅通！',
        name: '姓名',
        nameRule: '请输入名称',
        eMail: 'E-mail',
        eMailRule: '请输入邮箱',
        comp: '公司名称',
        compRule: '请输入公司名称',
        position: '职位',
        positionRule: '请输入职位',
        mobile: '手机号码',
        mobileRule: '请输入手机号',
        consuContent: '咨询内容',
        consuContentRule: '请填充咨询内容',
        sub: '提交'
    },
    showRightDataList:{
        console: '控制台',
        exit: '退出',
        register: '登录'
    },
    remarks:'Copyright©2022 企业应用及银行直连平台',
    message:{
        language: '设置语言成功'
    }
}
  


// WEBPACK FOOTER //
// ./src/lang/zh.js